import React from 'react';
import Header from './components/Header';
import KpiOverview from './components/KpiOverview';
import Navigation from './components/Navigation';
import MainDisplay from './components/MainDisplay';
import DetailView from './components/DetailView';
import Footer from './components/Footer';
import './styles/App.css';

function App() {
  return (
    <div className="dashboard-container">
      <Header />
      <KpiOverview />
      <Navigation />
      <MainDisplay />
      <DetailView />
      <Footer />
    </div>
  );
}

export default App;